import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import useApiGet from '../hooks/getData';
import toast from 'react-hot-toast';
import axios from 'axios';
import { useSelector } from 'react-redux';

function TrendingConfig() {
  const token = Cookies.get("Snapta_Admin_Token");
  const { getData } = useApiGet();
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);

  const [minJoinedUsers, setMinJoinedUsers] = useState(4);
  const [minTotalCoins, setMinTotalCoins] = useState(500);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [isEdited, setIsEdited] = useState(false);

  useEffect(() => {
    const fetchTrendingConfig = async () => {
      setFetching(true);
      try {
        const res = await getData('/rooms/trending-config');
        setMinJoinedUsers(res?.data?.min_joined_users || 4);
        setMinTotalCoins(res?.data?.min_total_coins || 500);
      } catch (err) {
        console.error("Error fetching trending config:", err);
      } finally {
        setFetching(false);
      }
    };
    fetchTrendingConfig();
  }, []);

  const handleSave = async () => {
    if (!minJoinedUsers || !minTotalCoins || minJoinedUsers < 1 || minTotalCoins < 1) {
      toast.error("Please enter valid numbers");
      return;
    }
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const res = await axios.post(`${apiUrl}/rooms/trending-config`, {
        min_joined_users: minJoinedUsers,
        min_total_coins: minTotalCoins,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success(res?.data?.message || "Trending config updated!");
      setIsEdited(false);
    } catch (err) {
      toast.error("Something went wrong");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`dark:bg-primary ${isSidebarOpen ? "xl:pl-20" : "xl:pl-72"}`}>
      <div className="px-4 pb-10 pt-6 xl:px-6">
        <h2 className="text-[#000000] font-semibold font-poppins text-xl pb-5 dark:text-darkText">
          Trending Room Config
        </h2>

        {fetching ? (
          <p className="font-poppins dark:text-darkText">Loading...</p>
        ) : (
          <>
            <div className="border border-opacity-gradient dark:border-[#1F1F1F] bg-[#FFFFFF] dark:bg-primary rounded-lg p-6">
              <div className="grid gap-6 md:grid-cols-2">

                <div>
                  <label className="text-[#000000] font-poppins font-semibold text-sm dark:text-darkText">
                    Min Joined Users
                  </label>
                  <p className="text-xs text-[#777777] font-poppins pb-1">
                    Minimum users that must join a room for it to be marked "Trending"
                  </p>
                  <input
                    type="number"
                    min="1"
                    className="border dark:bg-transparent dark:text-darkText dark:border-borderColor border-opacity-gradient rounded-lg w-full py-3 my-1 px-4 bg-white focus:outline-none focus:ring-1 focus:ring-header"
                    value={minJoinedUsers}
                    onChange={(e) => { setMinJoinedUsers(e.target.value); setIsEdited(true); }}
                  />
                </div>

                <div>
                  <label className="text-[#000000] font-poppins font-semibold text-sm dark:text-darkText">
                    Min Total Coins
                  </label>
                  <p className="text-xs text-[#777777] font-poppins pb-1">
                    Minimum coins collected in a room for it to be marked "Trending"
                  </p>
                  <input
                    type="number"
                    min="1"
                    className="border dark:bg-transparent dark:text-darkText dark:border-borderColor border-opacity-gradient rounded-lg w-full py-3 my-1 px-4 bg-white focus:outline-none focus:ring-1 focus:ring-header"
                    value={minTotalCoins}
                    onChange={(e) => { setMinTotalCoins(e.target.value); setIsEdited(true); }}
                  />
                </div>

              </div>
            </div>

            <div className="flex justify-center py-8">
              <button
                style={{ backgroundColor: isEdited ? '#593A99' : '#B8A6D9' }}
                className="px-24 py-3 font-medium text-white rounded-xl transition-all"
                onClick={handleSave}
                disabled={loading}
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default TrendingConfig;